import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/components/Login.vue";
import Dashboard from "@/components/Dashboard.vue";

const Roles = () => import("@/views/roles/roles.vue");
const Users = () => import("@/views/Users/User.vue");
const Abogados = () => import("@/views/Users/abogados.vue");
const UpdatePassword = () => import("@/components/UpdatePassword");
const RecuperaPassword = () => import("@/components/RecuperaPassword");
const Logs = () => import("@/views/logs/log.vue");
const Home = () => import("../views/Home.vue");
const ShowPromocion = () => import("@/views/Ordenes/show.vue");
const Panel = () => import("@/views/Ordenes/panel.vue");
// const Efirma = () => import("@/views/Ordenes/eFirma.vue");
const Contestacion = () => import("@/views/Ordenes/contestacion.vue");
const NotFound = () => import("@/views/NotFound.vue");
const Verificar = () => import("@/views/Verificar.vue");
// const Promociones = () => import("@/views/Promociones/Promociones.vue");
const PromocionesFirma = () => import("@/views/Promociones/PromocionesFirma.vue");
const Firma = () => import("@/views/Promociones/Firmar.vue");
const FirmaMagistrado = () => import("@/views/Promociones/FirmaMagistrado.vue");
const Multifirma = () => import("@/views/Promociones/Multifirma.vue");
const MultifirmaCreate = () => import("@/views/Promociones/MultifirmaCreate.vue");
const ContestacionMultifirma = () => import("@/views/Ordenes/contestacionMultifirma.vue");
const ReporteMagistrado = () => import("@/views/Promociones/reporteMagistrado.vue");
const ReportePromociones = () => import("@/views/Promociones/reportePromociones.vue");
const Estadistica = () => import("@/views/Promociones/estadistica.vue");
const Sentencia = () => import("@/views/Sentencias/SentenciasCreate.vue");
const Amparo = () => import("@/views/Amparos/AmparosCreate.vue");
const EscritosPanel = () => import("@/views/Ordenes/SentenciasPanel.vue");

Vue.use(VueRouter);
/*ROLES
  1 =>  SUPER-ADMIN

  CHECAR QUE COICINDAN CON LOS ASIGNADOS EM EL BACKEND
*/
const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
    alias: "/login"
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
    alias: "/Home"
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { authorize: [1, 2, 3, 4] }
  },

  {
    path: "/roles",
    name: "Roles",
    component: Roles,
    meta: { authorize: [1, 2] }
  },
  {
    path: "/user/editPassword",
    name: "UpdatePassword",
    component: UpdatePassword,
    meta: { authorize: [1, 2, 3, 4, 6, 7, 8] }
  },

  // {
  //   path: "/recuperar-pass*",
  //   name: "RecuperaPassword",
  //   component: RecuperaPassword,
  // },
  {
    path: "/users",
    name: "Users",
    component: Users,
    meta: { authorize: [1, 2] }
  },
  // {
  //   path: "/abogados",
  //   name: "Abogados",
  //   component: Abogados,
  //   meta: { authorize: [1, 2] }
  // },
  {
    path: "/logs",
    name: "Logs",
    component: Logs,
    meta: { authorize: [1, 2] }
  },
  {
    path: "/perfil",
    name: "Perfil",
    component: UpdatePassword,
    meta: { authorize: [1, 2, 3, 4, 5, 6, 7, 8] }
  },
  // {
  //   path: "/escritos/show",
  //   name: "ShowPromocion",
  //   component: ShowPromocion,
  //   meta: { authorize: [1, 2, 3, 4, 5, 6, 7, 8] }
  // },
  // {
  //   path: "/panel",
  //   name: "Panel",
  //   component: Panel,
  //   meta: { authorize: [1, 2, 3, 5, 7, 8] }
  // },
  // {
  //   path: "/efirma",
  //   name: "Efirma",
  //   component: Efirma,
  //   meta: { authorize: [1, 2] }
  // },
  {
    path: "/firma",
    name: "Firma",
    component: Firma,
    meta: { authorize: [1, 2, 4] }
  },
  {
    path :'*',
    component:NotFound
  },
  // {
  //   path :'/verificar*',
  //   name: "Verificar",
  //   component: Verificar,
  // },
  // {
  //   path: "/promociones/create",
  //   name: "Promociones",
  //   component: Promociones,
  //   meta: { authorize: [1, 2, 3] }
  // },
];

const router = new VueRouter({
  mode: "history",
  routes
});

router.beforeEach((to, from, next) => {
  const { authorize } = to.meta;
  const userLogged = JSON.parse(localStorage.getItem("user"));
  const currentOrden = JSON.parse(localStorage.getItem("currentOrden"));
  if (authorize) {
    //si si tiene restricciones la ruta
    if (!userLogged) {
      //y no esta logeado entonces a logear
      return next({
        path: "/"
      });
    }
    //checar si la routa esta restringida por algun role_id y  NO coincide el role_id del user logeado
    if (authorize.length && !authorize.includes(userLogged.roles[0].id)) {
      // if (userLogged.roles[0].id == 4 || userLogged.roles[0].id == 6) {
      //   return next({ path: "/escritos/panel" });
      // }
      return next({ path: "/firma" });
    }
  }
  if ((to.path === "/" || to.path === "/login") && userLogged) {
    return next({ path: "/firma" });
  }
  if (to.name === undefined) {
    return next({ path: "/firma" });
  }
  next();
});

export default router;
